import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
import lucideMixin from "./mixins/lucide";

Vue.config.productionTip = false;

Vue.use(VueMeta, {
  refreshOnceOnNavigation: false,
});
// 全域註冊 Lucide Icons Mixin
Vue.mixin(lucideMixin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
